const LotSmartTypes = {
  FETCH_LOTSMART_MERCHANTS: "FETCH_LOTSMART_MERCHANTS",
  FETCH_LOTSMART_RATES: "FETCH_LOTSMART_RATES",
  FETCH_LOTSMART_SPECIAL_RATES: "FETCH_LOTSMART_SPECIAL_RATES",
  FETCH_LOTSMART_AUDIT_LOGS: "FETCH_LOTSMART_AUDIT_LOGS",
  LOTSMART_GATE_RESULT: "LOTSMART_GATE_RESULT",
  LOTSMART_LOADER: "LOTSMART_LOADER",
};

export default LotSmartTypes;
